<template>
  <input type="date" :min="minDate" @input="setDate">
</template>

<script>

export default {
  props: {
    minDate: {
      type: String,
      default: ''
    }
  },
  data () {
    return { };
  },
  methods: {
    setDate (value) {
      this.$emit('setDate', value?.target?.value);
    }
  }
};
</script>

<style scoped>
  input[type="date"] {
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    background-color: #f9f9f9;
    color: #333;
  }

  input[type="date"]:hover {
    border-color: darkgray;
  }

  input[type="date"]::-webkit-calendar-picker-indicator {
    cursor: pointer;
  }
</style>
